export default {"src":"/_next/static/media/Vector-radial-circles.d31a6541.svg","height":113,"width":115,"blurWidth":0,"blurHeight":0};